import React from 'react';
import './styles.css';
import SvgIcon, { iconList } from '../../../share/components/iconSVG';
import { useNavigate } from 'react-router-dom';

function MenuSideBarHome({ clearSideBar }) {
  const navigate = useNavigate();

  const optionsList = [
    { text: 'Inicio', icon: iconList.IconHospital, url: '/' },
    { text: 'Mi Perfil', icon: iconList.IconProfile, url: '/profile' },
    { text: 'Travel', icon: iconList.IconPlane, url: '/fligths' },
    { text: 'Nosotros', icon: iconList.IconPeoples, url: '/aboutus' },
    { text: 'Especialidades y Servicios', icon: iconList.IconListItem, url: '/aboutus' },
    { text: 'Arma Tu Paquete', icon: iconList.IconTravel, url: 'https://wa.link/640gfp' },
  ]

  function goToOptionMenu(screen) {
    const urlPattern = /^(https?:\/\/)?([\w.]+)\.([a-z]{2,})(\/[\w .-]*)*\/?$/i;
    const extarnalURL = urlPattern.test(screen);
    extarnalURL
      ? window.location.href = screen
      : navigate(`${screen}`, {})
    clearSideBar(false);
  }

  return (
    <div className='MenuSideBarHome'>
      <div className='MenuSideBarHomeContainer'>
        {optionsList.map((index, key) => {
          return (
            <div key={key} className='MenuSideBarHomeOption' onClick={() => goToOptionMenu(index?.url)}>
              <div className='MenuSideBarHomeOptionIcon'>
                <SvgIcon name={index?.icon} color={'#FFFFFF'} size={25} />
              </div>
              <p className='MenuSideBarHomeOptionText'>{index?.text}</p>
            </div>
          )
        })}
        <div className='MenuSideBarHomeFooter'>
          <p className='MenuSideBarHomeFooterText'>
            © Wellezy - All rights reserved.
          </p>
        </div>
      </div>
    </div>
  )
}

export default MenuSideBarHome;
